// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2PeLQ","col":"styles_col__3-qA1","fulfillmentStatus":"styles_fulfillmentStatus__1HKwV","emailCol":"styles_emailCol__bKoCH"};